import { render, staticRenderFns } from "./BillingsHistory.vue?vue&type=template&id=295569ea&"
import script from "./BillingsHistory.vue?vue&type=script&lang=js&"
export * from "./BillingsHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports